import './mobile_nav.less';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import reduce from 'lodash/reduce';

import MobileSocialLinks from './mobile_nav.mobile_social_links.jsx';
import MobileMenu from './mobile_nav.mobile_menu.jsx';
import { LINK_TYPE_EXTERNAL } from 'zoomforth_codesbane_viewer/const/link_types.js';
import { slide as BurgerMenu } from 'react-burger-menu';

import {
  APP_CONTAINER_SELECTOR
} from 'zoomforth_codesbane_viewer/const/dom_selectors.js';

class MobileNav extends Component {

  constructor(props) {
    super(props);

    this.oldPaddingTop = null;

    this.state = {
      isMenuOpen: false
    };
  }

  componentDidMount() {
    // HACK: We need to match the hacky way that the non-react
    // customer page created space in the APP_CONTAINER_SELECTOR for 
    // the mobile menu top bar
    this.oldPaddingTop = $(APP_CONTAINER_SELECTOR).css('padding-top');

    $(APP_CONTAINER_SELECTOR).css({
      'padding-top': $(this.menuOpenerRef).outerHeight()
    });
    // ENDHACK
  }

  componentWillUnmount() {
    // HACK: Remove application-container padding-top hack
    $(APP_CONTAINER_SELECTOR).css({
      'padding-top': this.oldPaddingTop
    });
    // ENDHACK
  }

  render() {
    const {
      currentSubpage,
      isInPageSearchEnabled,
      menuItems,
      shouldShowSocialLinks,
      socialLinks,
      submenuItemsBySubpageId,
      lastClickedSubmenuItemId,
      onMobileMenuItemClick,
      onMobileSubmenuItemClick,
      onSearchInPageClick,
      isUsingLegacyHeader,
      isTranslationsEnabled,
      appliedLanguages,
      currentLanguageIso,
      defaultLanguageIso,
      onLanguageChange
    } = this.props;

    const anyEnabledSocialLinks = reduce(socialLinks, (anyEnabledSoFar, { enabled }) => {
      return anyEnabledSoFar || !!enabled;
    }, false) && shouldShowSocialLinks;

    if (!currentSubpage) {
      return null;
    }

    const shouldShowMenuButton = !!(
      menuItems.length > 1 ||
      (submenuItemsBySubpageId[currentSubpage.id] || []).length
    );

    const shouldHideMenuBar = !currentSubpage || (!shouldShowMenuButton && !anyEnabledSocialLinks);

    if (shouldHideMenuBar) {
      return null;
    }

    return (
      <div
        ref={(menuOpenerRef) => {
          this.menuOpenerRef = menuOpenerRef;
        }}
        className={classNames('nav-opener-container', {
          'nav-is-open': this.state.isMenuOpen,
        })}
      >
        {shouldShowMenuButton && (
          <BurgerMenu
            isOpen={this.state.isMenuOpen}
            styles={{
              bmItemList: {
                height: 'auto',
              },
            }}
            width={'85%'}
            right
            onStateChange={(menuState) => {
              this.setState({ isMenuOpen: menuState.isOpen });
            }}
            customBurgerIcon={
              isUsingLegacyHeader ? (
                <div>
                  <div key='1' className='nav-opener-icon'>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                  <div key='2' className='nav-opener-header-text'>
                    Menu
                  </div>
                </div>
              ) : (
                <div>
                  <div key='1' className='new-header-nav-opener-icon'>
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </div>
              )
            }
          >
            <MobileMenu
              isOpen={this.state.isMenuOpen}
              currentSubpage={currentSubpage}
              isInPageSearchEnabled={isInPageSearchEnabled}
              menuItems={menuItems}
              submenuItemsBySubpageId={submenuItemsBySubpageId}
              lastClickedSubmenuItemId={lastClickedSubmenuItemId}
              isTranslationsEnabled={isTranslationsEnabled}
              currentIso={currentLanguageIso}
              defaultLanguageIso={defaultLanguageIso}
              appliedLanguages={appliedLanguages}
              onLanguageChange={onLanguageChange}
              onMobileMenuItemClick={(menuItem) => {
                if (menuItem.appAction.type !== LINK_TYPE_EXTERNAL) {
                  this.setState({ isMenuOpen: false });
                }
                onMobileMenuItemClick(menuItem);
              }}
              onMobileSubmenuItemClick={(submenuItem) => {
                if (submenuItem.appAction.type !== LINK_TYPE_EXTERNAL) {
                  this.setState({ isMenuOpen: false });
                }
                onMobileSubmenuItemClick(submenuItem);
              }}
              onSearchInPageClick={() => {
                this.setState({ isMenuOpen: false });
                onSearchInPageClick();
              }}
            />
          </BurgerMenu>
        )}
        {anyEnabledSocialLinks && (
          <MobileSocialLinks socialLinks={socialLinks} />
        )}
      </div>
    );
  }

}

MobileNav.propTypes = {
  currentSubpage: PropTypes.object,
  isInPageSearchEnabled: PropTypes.bool.isRequired,
  menuItems: PropTypes.array,
  submenuItemsBySubpageId: PropTypes.object,
  lastClickedSubmenuItemId: PropTypes.string,
  shouldShowSocialLinks: PropTypes.bool.isRequired,
  socialLinks: PropTypes.arrayOf(PropTypes.shape({
    serviceName: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    target: PropTypes.string.isRequired
  })),
  onMobileMenuItemClick: PropTypes.func.isRequired,
  onMobileSubmenuItemClick: PropTypes.func.isRequired,
  onSearchInPageClick: PropTypes.func.isRequired
};

export default MobileNav;
